import { useFormikContext } from "formik"
import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { DatePicker } from "@mui/x-date-pickers"
import { StandardAlertInfo } from "../../../../../../shared/components/alert/StandardAlertInfo"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { SupplierFormValues } from "../../supplier/supplierTypes"

const useStyles = makeStyles()(() => ({
    field: {
        width: "50%",
    },
}))

export function SubscriptionDetailsContent() {
    const { classes } = useStyles()
    const { values, setFieldValue, errors } = useFormikContext<SupplierFormValues>()

    return (
        <>
            <LocalizedStrict id="support-create-entity-subscription-details-subtitle">
                <Typography mb="0.5rem" fontWeight={400}>
                    Subscription details
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict
                id="support-create-entity-subscription-details-field-implementationDeadline"
                attrs={{ label: true }}
            >
                <DatePicker
                    value={values.implementationDeadline}
                    onChange={(newValue: any) => {
                        if (newValue) {
                            setFieldValue("implementationDeadline", newValue)
                        }
                    }}
                    label="Deadline for implementation *"
                    slotProps={{
                        textField: {
                            error: !!errors.implementationDeadline,
                            helperText: errors.implementationDeadline,
                        },
                    }}
                    className={classes.field}
                />
            </LocalizedStrict>

            <LocalizedStrict id="support-create-entity-subscription-details-alert-title" attrs={{ title: true }}>
                <StandardAlertInfo title="This is the date by which the customer wants the system to go into production. This means onboarding, internal testing and any trial period must be completed before this date." />
            </LocalizedStrict>
        </>
    )
}
